<div class="dialogMainContainer">
    <div class="titleContainer">
        <span class="otherFont">Student Outing Details</span>
        <span class="otherFont" style="cursor: pointer;" (click)="closeDialog()">X</span>
    </div>
    <div class="studentDataContainer">
        <div class="subStudentDataContainer" *ngIf="data.requestType =='SINGLE'">
            <span class="titleFont">Student Name</span>
            <span class="dataFont">{{requestData.studentName}}</span>
            <span class="numberFont">{{requestData.admNo}}</span>
        </div>
         <div class="subStudentDataContainer" *ngIf="data.requestType =='BULK'">
            <span class="titleFont">Section Name</span>
            <span class="dataFont">{{data.sectionName}}</span>
        </div>

        <div class="subStudentDataContainer" *ngIf="data.requestType =='BULK'">
            <span class="titleFont">No Of Students</span>
            <span class="dataFont">{{studentCount}}</span>
        </div>

        <div class="subStudentDataContainer" *ngIf="data.requestType =='SINGLE'">
            <span class="titleFont">Authorized Parent</span>
            <span class="dataFont">{{requestData.fName}}</span>
            <span class="numberFont">{{requestData.fMobileNo}}</span>
        </div>
          <div class="subStudentDataContainer" *ngIf="data.requestType =='BULK'">
            <span class="titleFont">Authorized Person</span>
            <span class="dataFont">{{data.CreatedBy}}</span>
            <span class="numberFont">{{data.payrollId}}</span>
        </div>
        <div class="subStudentDataContainer">
            <span class="titleFont">Reason for Outing</span>
            <span class="otherFont">{{data.description}}</span>
        </div>
        <div class="subStudentDataContainer" style="display:flex;flex-direction: row;gap: 1%;">
            <div class="dateContainer">
                <span class="titleFont">Out Time</span>
                <span class="otherFont">{{data.outingTime}}</span>
            </div>
            <div class="dateContainer">
                <span class="titleFont">In Time</span>
                <span class="otherFont">{{data.inTime}}</span>
            </div>
        </div>
        <div class="subStudentDataContainer">
            <span class="titleFont">Remarks</span>
            <span class="dataFont">We will celebrate Bonalu Festival in our home town</span>
        </div>
    </div>
    <div class="imageContainer" *ngIf="data.requestType =='SINGLE'">
        <div class="imageBox">
            <img src="../../../../assets/image/outing/studentIcon.svg" alt="">
            <span class="titleFont">Student</span>
        </div>
        <div class="imageBox">
            <img src="../../../../assets/image/outing/parentIcon.svg" alt="">
            <span class="titleFont">Authorized Parent</span>
        </div>
    </div>
    <div class="tabcontainer" *ngIf="approved">
        <span class="tab" [class.active]="activeTab === 'approved'" (click)="setTab('approved')">Approved</span>
        <span class="tab" [class.active]="activeTab === 'rejected'" (click)="setTab('rejected')"
            style="width: 58px;">Rejected</span>
    </div>
    <div *ngIf="approved && activeTab === 'approved'" class="selectContainer">
        <!-- <label for="approvalEmployee">Approved By</label> -->
        <div class="approvedByContianner">
            <mat-select id="approvalEmployee" class="flex-center" placeholder="Select Approved Employee "
                [(ngModel)]="selectedApprovedEmp">

                <input matInput [matAutocomplete]="campusOptionsauto" [formControl]="approvedFilter"
                    class="input inputborderpopup" placeholder="Enter payrollId  ">
                <mat-autocomplete #campusOptionsauto="matAutocomplete"></mat-autocomplete>
                <!-- <i class="fa-solid fa-magnifying-glass"></i> -->

                <mat-option *ngFor="let item of approvedOptions |async" [value]="item"
                    (click)="getApprovedEmployee(item)">{{item.userName}}</mat-option>
            </mat-select>
        </div>

    </div>
    <div class="buttonContianer" *ngIf="approved && activeTab === 'approved'">
        <button class="button" (click)="openQr()">Submit and generate QR code</button>
    </div>
    <div *ngIf="!approved && activeTab === 'approved'" class="qrContainer">
        <div class="subQrcontianer">
            <img style="width: 100%; height: 100%;" [src]=qrImage alt="">
        </div>
        <div class="subQrcontianer">
            <button class="button" (click)="printQR()"
                style="height: 40px;width: 80%;display: flex;justify-content: space-evenly;align-items: center;">
                <img src="../../../../assets/image/outing/downloadIcon.svg" alt="">Print QR Code</button>
            <button class="button" (click)="shareQR()"
                style="height: 40px;width: 80%;display: flex;justify-content: space-evenly;align-items: center;">
                <img src="../../../../assets/image/outing/shareIcon.svg" alt="">Share QR Code</button>
        </div>
    </div>
</div>